import StyledButtonV2 from "@/components/app/StyledButtonV2";
import FilterBuilder from "@/components/filter/FilterBuilder";
import { FilterRecord } from "@/components/filter/filter-constant";
import Flex from "@/components/Flex";
import LabeledSwitch from "@/components/LabeledSwitch";
import SearchInput from "@/components/SearchInput";
import { PayersControls } from "../hooks/use-payers-controls";
import {
  PAYER_FILTER_PLACEHOLDER,
  PAYER_SEARCH_PLACEHOLDER,
  PAYER_SHOW_ARCHIVED_LABEL,
  PAYER_STATUS_OPTIONS,
  PAYER_TITLE,
  PAYER_TYPE_OPTIONS,
  PayerFilters,
} from "../payers-constant";

export interface PayersToolbarProps {
  controls: PayersControls;
  canAdd: boolean;
}

const SEARCH_WIDTH = "391px";
const FILTER_PANEL_HEIGHT = "12rem";

const PAYER_FILTERS: FilterRecord = {
  payerType: {
    type: "custom_select",
    label: PAYER_FILTER_PLACEHOLDER.TYPE,
    placeholder: PAYER_FILTER_PLACEHOLDER.TYPE,
    options: PAYER_TYPE_OPTIONS,
  },
  status: {
    type: "custom_select",
    label: PAYER_FILTER_PLACEHOLDER.STATUS,
    placeholder: PAYER_FILTER_PLACEHOLDER.STATUS,
    options: PAYER_STATUS_OPTIONS,
  },
};

const PayersToolbar = ({ controls, canAdd }: PayersToolbarProps) => {
  const { searchKey, filters, isArchivedView, drawer } = controls;
  const activeFilterCount = Object.values(filters).filter(Boolean).length;

  return (
    <Flex
      gap={2}
      flexWrap="nowrap"
      alignItems="center"
      justifyContent="flex-end"
    >
      <LabeledSwitch
        label={PAYER_SHOW_ARCHIVED_LABEL}
        checked={isArchivedView}
        onChange={(e) => controls.onArchivedViewChange(e.target.checked)}
      />
      <SearchInput
        searchKey={searchKey}
        onSearch={controls.onSearch}
        placeholder={PAYER_SEARCH_PLACEHOLDER}
        sx={{ width: SEARCH_WIDTH }}
      />
      <FilterBuilder<Partial<PayerFilters>>
        filters={PAYER_FILTERS}
        prefillValues={{
          payerType: filters.payerType ?? undefined,
          status: filters.status ?? undefined,
        }}
        onApply={controls.onFiltersApply}
        activeFilterCount={activeFilterCount}
        h={FILTER_PANEL_HEIGHT}
      />
      {canAdd && (
        <StyledButtonV2
          label={PAYER_TITLE.ADD}
          onClick={drawer.open}
          shouldAddIcon
        />
      )}
    </Flex>
  );
};

export default PayersToolbar;
